import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/AppText";

const TransactionEmpty = (props) => {
  const { SvgComponent, message = "" } = props;

  return (
    <View style={styles.container}>
      <SvgComponent />
      <Text
        fontType="head3"
        style={{ color: "rgba(0, 0, 0, 0.56)", textAlign: "center" }}
      >
        {message}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
});

export default TransactionEmpty;
